var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: { display: _vm.displayAudiowaves } }, [
    _vm._m(0),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "bars" } }, [
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" }),
      _c("div", { staticClass: "bar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "bars2" } }, [
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" }),
      _c("div", { staticClass: "bar2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }